import { jsxs as M, jsx as u } from "react/jsx-runtime";
import { forwardRef as g, useRef as w, useState as R, useEffect as y } from "react";
import n from "sanitize-html";
import f from "classnames";
import z from "../../hooks/useRefWithForm.js";
const N = "forma-ui__content-editable__root", $ = "forma-ui__content-editable__editable", v = "forma-ui__content-editable__placeholder", i = {
  root: N,
  editable: $,
  placeholder: v
}, r = {
  allowedTags: ["b", "i", "em", "u", "strong", "span", "br", "ol", "ul", "li"],
  allowedAttributes: {
    "*": ["style"]
  },
  allowedStyles: {
    "*": {
      "text-decoration": [/^underline$/],
      "text-decoration-line": [/^underline$/],
      "font-style": [/^italic$/],
      "font-weight": [/^bold$/]
    }
  }
}, V = g(({
  value: a = "",
  onChange: s,
  placeholder: m,
  className: p,
  containerClassName: b,
  readOnly: h,
  minLength: D,
  maxLength: E,
  ..._
}, L) => {
  const e = w(null);
  z(e, L);
  const [H, l] = R(n(a, r));
  y(() => {
    if (!e.current)
      return;
    const t = n(a, r);
    n(e.current.innerHTML, r) !== t && (e.current.innerHTML = t, l(t));
  }, [a, e.current]);
  const T = () => {
    if (!e.current)
      return;
    const t = n(e.current.innerHTML, r);
    l(t), s(t);
  }, x = (t) => {
    if (!e.current)
      return;
    let o = e.current.innerHTML;
    const c = t.clipboardData.getData("text/html"), d = n(c, r);
    d !== c && (t.preventDefault(), document.execCommand("insertHTML", !1, d), o = e.current.innerHTML), l(o), s(o);
  };
  return /* @__PURE__ */ M("div", { className: f(i.root, b), children: [
    /* @__PURE__ */ u(
      "div",
      {
        className: f(i.editable, "content-editable", p),
        onInput: T,
        contentEditable: !h,
        onPaste: x,
        ..._,
        ref: e
      }
    ),
    !H.length && /* @__PURE__ */ u("span", { className: i.placeholder, children: m ?? "" })
  ] });
});
export {
  V as default
};
